 (function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-wide-settings', {
            parent: 'entity',
            params:{screen: 'UserAdminApplicationWideSettings'},
            url: '/application-wide-settings/{userId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.userProfile.userProfile" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-wide-settings-useradmin/application-wide-settings.html',
                    controller: 'ApplicationWideSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:true});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('applicationWideSettings');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
         };
    })();
